export const resetReservationState = "reset ReservationState";

export const updateReservationState = "Update ReservationState Mutation";

export const updateFormData = "Update Form Data Mutation";

export const updateFormResult = "Update Form Result Mutation";

export const updateReviewData = "Update ReviewData Mutation";

export const updatePendingReservation = "Update PendingReservation Mutation";
